import React from 'react';
import { Filter, Calendar } from 'lucide-react';

export default function ErrorFilters({ filters, onFiltersChange }) {
  const severityLevels = ['critical', 'warning', 'info'];
  const resolutionStatuses = ['unresolved', 'investigating', 'resolved', 'ignored'];

  const handleSeverityToggle = (severity) => {
    const current = filters?.severity || [];
    const updated = current?.includes(severity)
      ? current?.filter(s => s !== severity)
      : [...current, severity];
    onFiltersChange({ ...filters, severity: updated });
  };

  const handleResolutionStatusChange = (status) => {
    onFiltersChange({ ...filters, resolutionStatus: status });
  };

  const handleDateChange = (field, value) => {
    onFiltersChange({ ...filters, [field]: value });
  };

  const clearFilters = () => {
    onFiltersChange({
      severity: [],
      errorType: null,
      resolutionStatus: 'unresolved',
      startDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)?.toISOString(),
      endDate: new Date()?.toISOString()
    });
  };

  return (
    <div className="bg-gray-50 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold text-gray-900 flex items-center">
          <Filter className="w-4 h-4 mr-2" />
          Filters
        </h3>
        <button
          onClick={clearFilters}
          className="text-xs text-blue-600 hover:text-blue-700"
        >
          Clear All
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Severity Levels */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">
            Severity
          </label>
          <div className="space-y-1">
            {severityLevels?.map((severity) => (
              <label key={severity} className="flex items-center space-x-2 text-sm">
                <input
                  type="checkbox"
                  checked={filters?.severity?.includes(severity)}
                  onChange={() => handleSeverityToggle(severity)}
                  className="rounded border-gray-300"
                />
                <span className="text-gray-700 capitalize">{severity}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Resolution Status */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">
            Resolution Status
          </label>
          <select
            value={filters?.resolutionStatus || ''}
            onChange={(e) => handleResolutionStatusChange(e?.target?.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
          >
            <option value="">All</option>
            {resolutionStatuses?.map((status) => (
              <option key={status} value={status}>
                {status?.replace('_', ' ')?.charAt(0)?.toUpperCase() + status?.slice(1)}
              </option>
            ))}
          </select>
        </div>

        {/* Date Range */}
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-2">
            <Calendar className="w-3 h-3 inline mr-1" />
            Date Range
          </label>
          <div className="space-y-2">
            <input
              type="date"
              value={filters?.startDate?.split('T')?.[0] || ''}
              onChange={(e) => handleDateChange('startDate', new Date(e.target.value)?.toISOString())}
              className="w-full border border-gray-300 rounded-lg px-3 py-1 text-xs"
            />
            <input
              type="date"
              value={filters?.endDate?.split('T')?.[0] || ''}
              onChange={(e) => handleDateChange('endDate', new Date(e.target.value)?.toISOString())}
              className="w-full border border-gray-300 rounded-lg px-3 py-1 text-xs"
            />
          </div>
        </div>
      </div>
    </div>
  );
}